import React from 'react';
import { Button } from "@mui/material";
import { BarChart2, Home, NotebookPen, Settings, User } from "lucide-react";

const NavigationMenu = ({ activeTab, onTabChange }) => {
    const menuItems = [
        { id: 'home', icon: Home, label: 'Главная' },
        { id: 'stats', icon: BarChart2, label: 'Статистика' },
        { id: 'notes', icon: NotebookPen, label: 'Заметки' },
        { id: 'settings', icon: Settings, label: 'Настройки' },
        { id: 'account', icon: User, label: 'Аккаунт' },
    ];

    return (
        <nav className="fixed md:w-64 md:min-h-screen md:top-0 bottom-0 left-0 right-0 md:right-auto z-50 h-[76px] md:h-full border-t md:border-t-0 md:border-r border-white/15 bg-[#101824]/98 shadow-[0_-16px_40px_rgba(0,0,0,0.32)] backdrop-blur-xl md:p-5 md:shadow-none">
            <div className="hidden md:block mb-8">
                <p className="text-xs uppercase tracking-[0.24em] text-teal-300/80">Financer</p>
                <h1 className="mt-2 text-2xl font-bold text-white">Личные финансы</h1>
            </div>

            <ul className="flex md:flex-col md:space-y-2 justify-around md:justify-start h-full md:h-auto p-2 md:p-0">
                {menuItems.map(({ id, icon: Icon, label }) => {
                    const isActive = activeTab === id;
                    return (
                        <li key={id} className="flex-1 md:flex-none">
                            <Button
                                fullWidth
                                onClick={() => onTabChange(id)}
                                className="!min-w-0 h-full md:h-12"
                                sx={{
                                    justifyContent: { xs: 'center', md: 'flex-start' },
                                    gap: 1.5,
                                    color: isActive ? '#061014' : '#cbd5e1',
                                    background: isActive
                                        ? 'linear-gradient(135deg, #2dd4bf, #fbbf24)'
                                        : 'transparent',
                                    borderRadius: '8px',
                                    '&:hover': {
                                        background: isActive
                                            ? 'linear-gradient(135deg, #2dd4bf, #fbbf24)'
                                            : 'rgba(148, 163, 184, 0.10)'
                                    }
                                }}
                            >
                                <Icon size={22} />
                                <span className="hidden md:inline">{label}</span>
                            </Button>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default NavigationMenu;
